// extracted by mini-css-extract-plugin
module.exports = {"w1pv6o1i":"w1pv6o1i"};